{
  "pt": {
    "unit": {
      "actions": {
        "bulk": {
          "activate": "Ativar unidades",
          "deactivate": "Desativar unidades",
          "give_access": "Dar acesso aos clientes",
          "revoke_access": "Revogar o acesso dos clientes"
        },
        "revokeAccess": "Revogar o acesso",
        "select": "Selecionar o tipo",
        "selectOutdoorCategory": "Selecionar o espaço exterior",
        "selectUnit": "Selecionar unidade",
        "setCustomer": "Atribuir um cliente a",
        "setVisible": "Dar acesso",
        "submit": "Enviar",
        "update_pricing": "Atualizar preços"
      },
      "attributes": {
        "address_city": "Cidade",
        "address_country": "País",
        "address_number": "Número",
        "address_street": "Rua",
        "address_zip": "Código postal",
        "amount": "Montante",
        "bathrooms": "Número de casas de banho",
        "bedrooms": "Número de quartos",
        "category": "Tipo",
        "category_outdoor": "Espaço exterior",
        "customer": "Cliente",
        "deed_signed_at": "Data da troca de contratos",
        "description": "Descrição",
        "electricity": "Eletricidade",
        "floor": "Armazém",
        "house_subcategory": "Tipo de habitação",
        "internal_note": "Nota interna da unidade",
        "meter_number": "Número do contador",
        "meter_number_electricity": "Número do contador de eletricidade",
        "meter_number_gas": "Número do contador de gás",
        "meter_number_warmth": "Número do contador Calor",
        "meter_number_water": "Número do contador de água",
        "meter_numbers": "Números dos contadores",
        "name": "Nome",
        "orientation": "Orientação",
        "price_value": "Valor total das vendas",
        "price_value_construction": "Valor da construção",
        "price_value_construction_existing": "Custos da construção existente",
        "price_value_fees": "Honorários do arquiteto/engenheiro",
        "price_value_land": "Valor do terreno",
        "quotity": "Parcela do montante da transferência",
        "sales_employee": "Representante de vendas",
        "status": "Estado",
        "surface_garden": "Jardim de superfície",
        "surface_terrace": "Terraço de superfície",
        "surface_total": "Superfície total",
        "tax_percentage": "Imposto %",
        "toilets": "Número de casas de banho",
        "total": "Total",
        "vat_percentage": "IVA %"
      },
      "house_subtype": {
        "detached": "Moradia isolada",
        "rowhouse": "Casa com terraço",
        "semidetached": "Casa geminada"
      },
      "labels": {
        "activate": "Ativar",
        "address": "Endereço",
        "areYouSureDeactivate": "Tem a certeza de que pretende desativar o {unit_name}?",
        "bathrooms": "casas de banho | casas de banho",
        "bedrooms": "quarto | quartos",
        "cannot_activate_all_units": "Não tem unidades suficientes para ativar todas as unidades seleccionadas",
        "deactivate": "Desativar",
        "deactivateMessage": "O cliente continua a poder comunicar consigo e a ter acesso a todas as suas informações. No entanto, todas as outras acções, como a criação de decisões, o carregamento de documentos, o envio de inquéritos, etc., para {unit_name} não serão possíveis.",
        "deactivated": "Desativado",
        "deedSignedOn": "Contratos assinados em {date}",
        "deedWillBeSignedOn": "Contratos será assinada em {date}",
        "detailed_price": "Detalhado",
        "details": "Detalhes",
        "email_address_secondary_delivery_content": "recebe e-mails de notificação como antigo contacto secundário",
        "email_address_secondary_delivery_tip": "Este cliente foi originalmente adicionado como um contacto secundário para o outro cliente, antes de ser introduzido o suporte para vários clientes por unidade: este cliente continuará a receber os mesmos e-mails de notificação que o outro cliente, mas apenas o outro cliente tem acesso à unidade/login.",
        "existingVatValues": "Alguns valores de IVA são diferentes de 0",
        "export": "Exportação",
        "export_preparing": "A recolha dos dados da unidade pode demorar alguns segundos.",
        "facing": "De frente para {direction}",
        "fromATotal": "Total do projeto: {total}",
        "general": "Geral",
        "howDoesCustomerSeeThis": "Como é que o cliente vê a sua unidade?",
        "integrationNoCustomerAssigned": "Não há cliente(s) atribuído(s), por favor atribuir cliente(s) em {integration_name}.",
        "internal": "Interno",
        "internalDisclaimer": "Esta informação só é visível para a sua equipa",
        "invitationAddEmailAddress": "Para dar a {customer} acesso à unidade, preencha primeiro o endereço de correio eletrónico na página de contacto do cliente.",
        "invitationAddEmailAddress_SUP": "Para dar a {customer} acesso ao projeto, preencha primeiro o endereço de correio eletrónico na página de contacto do cliente.",
        "invitationSentTo": "{customer} receberá o seu convite em breve em {email}",
        "maintainerNoCustomerAssigned": "Nenhum cliente atribuído, apenas os membros da equipa com a função \"Proprietário\" podem atribuir um cliente a uma unidade.",
        "more": "mais",
        "onFloor": "No piso",
        "or_create_new": "Criar novo",
        "other_units": "Tem outras unidades",
        "price_view": "Vista de preços",
        "sales_value": "Todos os preços são em {currency}",
        "scopes": {
          "invisible": "Sem acesso à unidade",
          "invisible_SUP": "Sem acesso ao projeto",
          "visible": "Tem acesso",
          "visible_SUP": "Tem acesso"
        },
        "search_unit": "Unidade de pesquisa ou cliente...",
        "selectUnit": "Selecionar uma unidade",
        "select_contact_required": "Por favor, selecione primeiro um contacto",
        "select_existing_contact": "Existente",
        "set_unit_price": "Definir preço unitário",
        "showUnit": "Mostrar unidade",
        "simple_price": "Simples",
        "toggleDetailedPrice": "Mudar a vista de preços",
        "unassigned": "Nenhum cliente atribuído",
        "unit": "Nenhuma unidade | Uma unidade | {count} Unidades",
        "unitLabel": "Unidade",
        "utilities": "Utilidades",
        "visibleCustomer": "Esta informação é visível para os clientes"
      },
      "outdoor_category": {
        "balcony": "Varanda",
        "garden": "Jardim",
        "null": "Nenhum",
        "terrace": "Terraço",
        "terrace_garden": "Terraço + Jardim"
      },
      "status": {
        "available": "Disponível",
        "unavailable": "Não disponível"
      },
      "toasts": {
        "activateSuccess": "{unit_name} foi ativado com sucesso",
        "create_fixed": "Unidade criada",
        "create_rundle": "Nova unidade ativa criada. 1 unidade ativa restante. | Nova unidade ativa criada. {count} unidades activas restantes.",
        "deactivateSuccess": "{unit_name} foi desativado com sucesso",
        "delete": "Unidade eliminada",
        "update": "Unidade actualizada"
      },
      "type": {
        "alf": "Centro de vida assistida",
        "apartment": "Apartamento",
        "cellar": "Adega",
        "commercial": "Comercial",
        "duplex": "Duplex",
        "house": "Casa",
        "loft": "Loft",
        "office": "Escritório",
        "penthouse": "Cobertura",
        "sme": "Unidade PME",
        "studio": "Estúdio"
      },
      "validation": {
        "needName": "O título é obrigatório",
        "needNumber": "Deve ser um número (por exemplo, 85)",
        "pricesNotUpdatable": "Alguns ou todos os preços foram utilizados para as prestações, pelo que não podem ser editados. Remova as prestações associadas para poder voltar a editar os preços",
        "totalSalesValueNotEqualToParts": "Parece que o valor total das vendas não é igual à soma das suas partes"
      }
    }
  }
}
